import { BootstrapTable, TableHeaderColumn, SearchField } from 'react-bootstrap-table'
import CheckBoxGroup from './CheckBoxGroup'
import RadioButtonGroup from './RadioButtonGroup'
import moment from 'moment'
import { Button, Popover, OverlayTrigger } from 'react-bootstrap'
import * as Utils from 'Assets/Utils'

moment.locale()

import React from 'react'
import numeral from 'numeral'

const TableData = ({
  id,
  onClickEdit,
  onClickRemove,
  onClickProcess,
  onClickView,
  onClickComponent,
  create,
  process,
  edit,
  remove,
  state,
  document,
  equalSize,
  toggleTableAll,
  page,
  cellEditCheck,
  onBeforeSaveCell,
  onAfterSaveCell,
  selectRowCheck,
  onRowSelect,
  onSelectAll,
  selected,
  sizePerPage,
  pageStartIndex,
  paginationSize,
  data,
  columns,
  disabled,
  search,
  multiColumnSearch,
  footer,
  footerData,
  expandableRow,
  expandComponent,
  expandColumnOptions,
  isNoPagination,
  onClickEtapas,
  rowSpan,
  custom,
  onClickCustom,
  rangosAsignar,
  onClickRangosyAsignar,
  selecion,
  onClickSelecion,
  arrayLink,
  onClickArrayLink,
  arrayChange,
  onClickChangeLink,
  customStyle,
  certificate,
  onClickCertificate,
  ajuste,
  onClickAjuste,
  onClickArrayLinkRadioCheck,
  upload,
  onClickUpload,
  onClickContract,
  createModal,
  viewDocument,
  viewDocumentReporte,
  trClassName,
  idRole,
	customToggle,
	disabledCheck,
  labelEdit,
  disableSlideTop = false,
  deletedKey = "deleted",
  view
}) => {
  const handleChange = (e, row) => {
    let validation = false // eslint-disable-line

    Array.from(e.target.files).forEach(f => {
      if (f.type !== 'application/pdf') {
        e.target.value = ''
        validation = true

        createModal(Utils.warningMessage('Únicamente archivos en formato PDF'))
      } else {
        if (onClickUpload) onClickUpload(e, row)
      }
    })
  }

  const createCustomSearchField = () => {
    return <SearchField className="custom-searchfield" placeholder="Buscar" />
  }

  const createCustomClearButton = onClick => {
    return (
      <button className="btn btn-primary" onClick={onClick}>
        Limpiar búsqueda
      </button>
    )
  }

  const renderShowsTotal = (start, to, total) => {
    return (
      <p>
        {start} a {to} de {total}
      </p>
    )
  }

  const cellEditProp = {
    mode: 'click',
    blurToSave: true,
    beforeSaveCell: onBeforeSaveCell,
    afterSaveCell: onAfterSaveCell
  }

  const selectRowPropCheck = {
    mode: 'checkbox',
    clickToSelect: false,
    selected: selected ? selected : [],
    onSelect: onRowSelect,
    onSelectAll: onSelectAll
	}

	if(disabledCheck == true) {
		let keysDisabled = []
		for(let key in data){
			keysDisabled.push(data[key].id)
		}
		selectRowPropCheck.unselectable = keysDisabled
	}

  const tableOptions = {
    page: page || 1,
    sizePerPage: sizePerPage || 10,
    pageStartIndex: pageStartIndex || 1,
    paginationSize: paginationSize || 5,
    prePage: '<',
    nextPage: '>',
    paginationShowsTotal: renderShowsTotal,
    paginationPosition: 'bottom',
    withoutNoDataText: false,
    noDataText: create ? ' ' : 'No hay registros por mostrar',
    hideSizePerPage: true,
    searchField: createCustomSearchField,
    clearSearch: true,
    clearSearchBtn: createCustomClearButton,
    expandRowBgColor: 'rgba(201, 201, 201, 0.2)',
    expanding: toggleTableAll,
    expandBy: 'column'
  }

  let tableColumns = []

  columns.map((option, key) => {
    const itemConfig = {
      dataField: option.id,
      dataSort: option.sort,
      starHide: option.stars,
      headerAlign: option.headerAlign ? option.headerAlign : 'left',
      dataAlign: option.dataAlign ? option.dataAlign : 'left',
      editable: option.editable ? option.editable : false,
      className: option.className
        ? option.className
        : option.index
        ? 'table-column-id'
        : option.columnaTipo
        ? 'table-column-type'
        : option.starHide
        ? 'table-column-hide'
        : 'table-column-data',
      columnClassName: option.columnClassName
        ? option.columnClassName
        : option.index
        ? 'table-column-id'
        : option.columnaTipo
        ? 'table-column-type'
        : 'table-column-data',
      key: key,
      hidden: option.hidden,
      row: option.row,
      rowSpan: option.rowSpan,
      colSpan: option.colSpan,
      width: option.width ? option.width : null,
      expandable: option.expandable
    }

    tableColumns.push(
      <TableHeaderColumn
        {...itemConfig}
        dataFormat={(cell, row) => {
          let field = ''

          if (option.type === 'simple') {
            field = row[option.id]
          } else if (option.type === 'object') {
            field = row[[option.object]] ? row[[option.object]][option.id] : ''
          } else if (option.type === 'currency') {
            field = numeral(row[option.id]).format('$ 0,0.00')
          } else if (option.type === 'percentage') {
            field = row[option.id] + ' %'
          } else if (option.type === 'date') {
            let date = row[option.id]
            field = 'No existe la fecha'
            if (date) {
              if (typeof date == 'string') {
                field = moment(date.substr(0, 10), 'YYYY-MM-DD').format('DD/MM/YYYY')
              }
            }
          } else if (option.type === 'datetime') {
            let date = row[option.id]
            field = 'No existe la fecha'
            if (date) {
              if (typeof date == 'string') {
                field = moment(date.substr(0, 19), 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY hh:mm:ss')
              }
            }
          } else if (option.type === 'doc-link') {
            field = (
              <a
                href="#"
                onClick={() => {
                  onClickView(row[option.id])
                }}
              >
                <i className="fa fa-paperclip" />
                &nbsp;{'Ver'}
              </a>
            )
          } else if (option.type === 'readOnlyCheck') {
            field = (
              <span className='table-icons check'>
                {
                  row[option.id] === true ? <i className='fa fa-check-square' /> : '-'
                }
              </span>
            )
          } else if (option.type === 'checkbox') {
            field = (
              <CheckBoxGroup
                id={option.nameOption}
                disabled={option.disabled ? option.disabled : false}
                options={[{ name: option.nameOption, checked: row[option.nameOption] }]}
                onChange={e => {
                  onClickComponent(e, 'checkbox', row)
                }}
              />
            )
          } else if (option.type === 'radio') {
            field = (
              <RadioButtonGroup
                id={option.nameOption}
                disabled={option.disabled ? option.disabled : false}
                name={id ? `${id}_${option.nameOption}` : `${row.id}_${option.nameOption}`}
                value={row[option.nameOption]}
                options={[{ value: row[option.nameOption], label: '' }]}
                onChange={e => {
                  onClickComponent(e, 'radio', row)
                }}
              />
            )
          } else if (option.type === 'radio_registro') {
            if (row.firmara) {
              field = (
                <span>
                  <a href="" disabled>
                    <i className={'fa fa-check-square-o'} /> {'Firmara'}
                  </a>
                </span>
              )
            } else {
              field = (
                <RadioButtonGroup
                  id={option.nameOption}
                  disabled={row.function === "Mancomunado" ? true : false}
                  name={id ? `${id}_${option.nameOption}` : `${row.id}_${option.nameOption}`}
                  value={row[option.nameOption]}
                  options={[{ value: row[option.nameOption], label: '' }]}
                  onChange={e => {
                    onClickComponent(e, 'radio', row)
                  }}
                />
              )
            }
          } else if (option.type === 'contrato') {
            field = (
              <span>
                <a href="#" onClick={() => onClickContract(row)}>
                  <i className={'fa fa-download'} /> {'Generar contrato'}
                </a>
              </span>
            )
          } else if (option.type === 'reciboPDF') {
            field = (
              <div>
                {disabled && (
                  <label>
                    <span className="a-href">
                      <input
                        name="reciboDocumento"
                        accept="application/pdf"
                        type="file"
                        style={{ display: 'none' }}
                        onChange={e => {
                          e.preventDefault()
                          onClickUpload(e, row)
                        }}
                      />{' '}
                      {row[option.id] ? (
                        <div>
                          <i className="fa fa-refresh" /> Actualizar
                        </div>
                      ) : (
                        <div>
                          <i className="fa fa-upload" /> Subir
                        </div>
                      )}
                    </span>
                  </label>
                )}
                &nbsp;
                <label>
                  <span>
                    <a
                      href="#"
                      className={!row[option.id] ? 'disabled' : ''}
                      onClick={() => {
                        onClickView(row[option.id])
                      }}
                    >
                      <i className={`fa ${!row[option.id] ? 'fa fa-eye-slash' : 'fa fa-eye'}`} />
                      &nbsp;{'Ver'}
                    </a>
                  </span>
                </label>
              </div>
            )
          } else if (option.type === 'XML') {
            field = (
              <div>
                {disabled && (
                  <label>
                    <span className="a-href">
                      <input
                        name="xmlDocumento"
                        accept="text/xml"
                        type="file"
                        style={{ display: 'none' }}
                        onChange={e => {
                          e.preventDefault()
                          onClickUpload(e, row)
                        }}
                      />{' '}
                      {row[option.id] ? (
                        <div>
                          <i className="fa fa-refresh" /> Actualizar
                        </div>
                      ) : (
                        <div>
                          <i className="fa fa-upload" /> Subir
                        </div>
                      )}
                    </span>
                  </label>
                )}
                &nbsp;
                <label>
                  <span>
                    <a
                      href="#"
                      className={!row[option.id] ? 'disabled' : ''}
                      onClick={
                        !row[option.id]
                          ? () => {
                              onClickUpload(row)
                            }
                          : () => {
                              onClickView(row[option.id])
                            }
                      }
                    >
                      <i className={`fa ${!row[option.id] ? 'fa fa-eye-slash' : 'fa fa-eye'}`} />
                      &nbsp;{'Ver'}
                    </a>
                  </span>
                </label>
              </div>
            )
          } else if (option.type === 'href') {
            field = (
              <span>
                <a
                  href="#"
                  className={row.estadoCambioDestinoId == 2 || row.estadoCambioDestinoId == null ? 'float-left' : 'clean-link'}
                  onClick={() => {
                    onClickView(row)
                  }}
                >
                  {' '}
                  {row[option.id]}{' '}
                </a>
              </span>
            )
          } else if (option.type === 'star') {
            let fieldStars = []

            for (let index = 1; index <= row.stars; index++) {
              fieldStars.push(
                <span>
                  <i className="fa fa-star" />
                </span>
              )
            }

            for (let index = row.stars; index < 5; index++) {
              fieldStars.push(
                <span>
                  <i className="fa fa-star-o" />
                </span>
              )
            }

            field = <div>{fieldStars}</div>
          }
          return field
        }}
      >
        {option.name}
      </TableHeaderColumn>
    )
  })

  if (state) {
    tableColumns.push(
      <TableHeaderColumn
        headerAlign={'right'}
        dataAlign={'right'}
        key={2}
        dataField={'deleted'}
        className="table-column-state"
        columnClassName="table-column-state"
        editable={false}
        dataFormat={(cell, row) => {
          let fieldDeleted = <div>{row[deletedKey] ? 'Inactivo' : 'Activo'}</div>

          let fieldEstado = <div>{row.subestado ? row.subestado : row.estado ? row.estado : ''}</div>

          let field = ''

          if (row.estado) {
            field = <div>{fieldEstado}</div>
          } else {
            field = <div>{fieldDeleted}</div>
          }

          return field
        }}
      >
        {'Estatus'}
      </TableHeaderColumn>
    )
  }

  if (
    !disabled &&
    (edit ||
      remove ||
      process ||
      document ||
      onClickEtapas ||
      custom ||
      certificate ||
      upload ||
      viewDocument ||
      viewDocumentReporte || view)
  ) {

    tableColumns.push(
      <TableHeaderColumn
        rowSpan={rowSpan}
        headerAlign={'center'}
        dataAlign={'center'}
        key={-2}
        expandable={false}
        dataField={'actions'}
        className={equalSize ? equalSize : !document ? 'assets-table-action' : ''}
        columnClassName={equalSize ? equalSize : !document ? 'assets-table-action' : ''}
        dataFormat={(cell, row) => {
          let customOption
          let selectEditCustom
          if (customToggle) {
            selectEditCustom = (
              <span className={''}>
                <a
                  href="#"
                  className={''}
                  onClick={e => {
                    e.preventDefault()
                    window.scroll(0, 200)
                    onClickCustom(row.id ? row.id : row)
                  }}
                >
                  { <i className={`fa ${row.activo*1 ? 'fa-toggle-off' : 'fa-toggle-on' }`} >&nbsp;<b>{row.activo*1 ? 'Desactivar' : 'Activar' }</b> </i> }
                </a>
                &nbsp;
              </span>
            )
          } else {
            selectEditCustom = (
              <span className={!row.select ? customStyle : ''}>
                <a
                  href="#"
                  className={row.disabledEdit && row.disabledEdit === true ? 'disabled' : ''}
                  onClick={e => {
                    e.preventDefault()
                    if(!disableSlideTop)
                      window.scroll(0, 200)
                    onClickEdit(row.id ? row.id : row)
                  }}
                >
                  <i className={'fa fa-pencil'}  />&nbsp;
                  { row.custom ? ( row.disabled ? "" : <b>{labelEdit ? labelEdit :'Editar'}</b>) : ( <b>{labelEdit ? labelEdit :'Editar'} </b>) }
                </a>
                &nbsp;
              </span>
            )
          }
          let editOption = edit && selectEditCustom
          let removeOption = remove && (
            <span>
              <a
                href="#"
                className={row.disabledRemove && row.disabledRemove === true ? 'disabled' : ''}
                onClick={e => {
                  e.preventDefault()
                  onClickRemove(row.id ? row.id : row)
                }}
              >
                <i className={'fa fa-trash'} />
                &nbsp;{'Eliminar'}
              </a>
              &nbsp;
            </span>
          )
          let viewOption = view && (
            <span>
              <a
                href="#"
                className={row.disabledView && row.disabledView === true ? 'disabled' : ''}
                onClick={e => {
                  e.preventDefault()
                  onClickView(row)
                }}
              >
                <i className={'fa fa-eye'} />
                &nbsp;{'Ver'}
              </a>
              &nbsp;
            </span>
          )
          let processOption = process && (
            <span>
              <a
                href="#"
                onClick={e => {
                  e.preventDefault()
                  onClickProcess(row.idTarea ? row.idTarea : row)
                }}
                className={((idRole === 7 && row.adquiridaPor) && (row.adquiridaPor !== sessionStorage.uid)) ? 'disabled' : ''}
              >
                <i className={'fa fa-tasks'} />
                &nbsp;{row.subestado == 'ADQUIRIDO' || !row.subestado ? 'Revisar' : 'Asignar'}
              </a>
              &nbsp;
            </span>
          )
          let documentOption = document && (
            <span>
              <a
                href="#"
                className={!row.documento.idDocumento ? 'disabled' : ''}
                onClick={e => {
                  e.preventDefault()
                  onClickView(row.documento.idDocumento)
                }}
              >
                <i className={!row.documento.idDocumento ? 'fa fa-eye-slash ' : 'fa fa-eye'} />
                &nbsp;{!row.documento.idDocumento ? 'N/A' : 'Ver'}
              </a>
              &nbsp;
            </span>
          )
          let etapasOption = onClickEtapas && (
            <span>
              <a
                href="#"
                onClick={e => {
                  e.preventDefault()
                  onClickEtapas(row.id)
                }}
              >
                <i className={'fa fa-tasks'} />
                &nbsp;{'Revisar'}
              </a>
              &nbsp;
            </span>
          )
          customOption =
            custom &&
            Array.isArray(custom) &&
            custom.map((custom, index) => {
              return (
                <tr key={index}>
                  <td>
                    <span>
                      <a
                        href="#"
                        onClick={e => {
                          e.preventDefault()
                          custom.actioner(row.id ? row.id : row)
                        }}
                      >
                        <i className={`fa ${custom.fa}`} />
                        &nbsp;{custom.label}
                      </a>
                      &nbsp;
                    </span>
                  </td>
                </tr>
              )
            })

          if (custom && !Array.isArray(custom))
            customOption = custom && !Array.isArray(custom) && (
              <span>
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault()
                    onClickCustom(row.id ? row.id : row)
                  }}
                >
                  <i className={`fa ${custom.fa}`} />
                  &nbsp;{custom.label}
                </a>
                &nbsp;
              </span>
            )

          let certificateOption = certificate && (
            <span>
              <a
                href="#"
                className={certificate.disabled ? 'disabled' : ''}
                onClick={e => {
                  e.preventDefault()
                  onClickCertificate(row.id ? row.id : row)
                }}
              >
                <i className={'fa fa-file-pdf-o'} />
                &nbsp;{'Certificado'}
              </a>
              &nbsp;
            </span>
          )
          let uploadOption = upload && (
            <label>
              <span className="a-href">
                <input
                  name={row.tipo && row.tipo.id ? row.tipo.id : ''}
                  type="file"
                  style={{ display: 'none' }}
                  onChange={e => {
                    e.preventDefault()
                    handleChange(e, row)
                  }}
                />{' '}
                {row.documento && row.documento.idDocumento ? (
                  <div>
                    <i className="fa fa-refresh" /> Actualizar
                  </div>
                ) : (
                  <div>
                    <i className="fa fa-upload" /> Subir
                  </div>
                )}{' '}
              </span>
            </label>
          )
          let viewDocumentOption = viewDocument && (
            <span>
              <a
                href="#"
                className={(row.documento && row.documento.idDocumento) || row.dropboxId ? '' : 'disabled'}
                onClick={e => {
                  e.preventDefault()
                  onClickView(row.documento ? row.documento : row.dropboxId)
                }}
              >
                <i className={(row.documento && row.documento.idDocumento) || row.dropboxId ? 'fa fa-eye' : 'fa fa-eye-slash'} />{' '}
                Ver
              </a>
              &nbsp;
            </span>
          )
          let viewDocumentOptionReporte = viewDocumentReporte && (
            <span>
              <a
                href="#"
                className={row.estado && row.estado === 'PROCESADO' ? '' : 'disabled'}
                onClick={e => {
                  e.preventDefault()
                  onClickView(row.url ? row.url : row.url)
                }}
              >
                <i className={row.estado && row.estado === 'PROCESADO' ? 'fa fa-eye' : 'fa fa-eye-slash'} /> Ver
              </a>
              &nbsp;
            </span>
          )

          const availableOptions = [
            {
              option: edit,
              component: editOption
            },{
              option: remove,
              component: removeOption
            },
            {
              option: view,
              component: viewOption
            },
            {
              option: process,
              component: processOption
            },
            {
              option: document,
              component: documentOption
            },{
              option: onClickEtapas,
              component: etapasOption
            },{
              option: custom || Array.isArray(custom),
              component: customOption
            },{
              option: certificate,
              component: certificateOption
            },{
              option: upload,
              component: uploadOption
            },{
              option: viewDocument,
              component: viewDocumentOption
            },{
              option: viewDocumentReporte,
              component: viewDocumentOptionReporte
            }]

          const popOverOptions =  (
            <Popover id="popover-options" title={`Menú de ${'\n'}opciones`}>
              <div>
                <table>
                  <tbody>
                    {availableOptions.filter(available => !(available.option === undefined || !available.option))
                    .map(({ component }, index) => (
                      <tr key={index}><td>{component}</td></tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Popover>
          )

          let field

          if (upload) {
            field = (
              <div>
                {editOption}&nbsp;{removeOption}&nbsp;{processOption}&nbsp;{documentOption}&nbsp;{etapasOption}&nbsp;
                {customOption}&nbsp;{certificateOption}&nbsp;{uploadOption}&nbsp;{viewDocumentOption}
              </div>
            )
          } else {
            if (availableOptions.filter(available => !(available.option === undefined || !available.option)).length >= 3) {
              field = (
                <div>
                  <OverlayTrigger trigger="focus" placement="right" overlay={popOverOptions}>
                    <span>
                      <a
                        href="#"
                        onClick={e => {
                          e.preventDefault()
                        }}
                      >
                        <i className="fa fa-bars" /> Opciones
                      </a>
                    </span>
                  </OverlayTrigger>
                </div>
              )
            } else {
              field = (
                <div>
                  {availableOptions.filter(available => !(available.option === undefined || !available.option))
                  .map(({component}) => (component))}
                </div>
              )
            }
          }
          return field
        }}
      >
        {'Acción'}
      </TableHeaderColumn>
    )
  }

  if (arrayLink || onClickArrayLink) {
    arrayLink.map(item => {
      tableColumns.splice(
        item.pos ? item.pos : tableColumns.length - 1,
        0,
        <TableHeaderColumn
          rowSpan={rowSpan}
          headerAlign={'center'}
          dataAlign={'center'}
          key={-2}
          dataField={'actions'}
          className={equalSize ? equalSize : !document ? 'assets-table-action' : ''}
          columnClassName={equalSize ? equalSize : !document ? 'assets-table-action' : ''}
          dataFormat={(cell, row) => {
            let arrayLinkOption = item.goTo && (
              <span className={row.evaluacionActiva ? customStyle : ''}>
                <a
                  href="#"
                  style={{ textDecoration: 'underline' }}
                  onClick={e => {
                    e.preventDefault()
                    onClickArrayLink(e, row.id ? row.id : row, item.goTo)
                  }}
                >
                  {' '}
                  {item.bodyColumn}{' '}
                </a>
              </span>
            )
            let arraySeleccionOption = item.titleHeader.includes('Selección') && (
              <span>
                <input
                  type="checkbox"
                  defaultChecked={row.select ? row.select : row.notificable}
                  onChange={e => {
                    onClickSelecion(e, row.id ? row.id : row)
                  }}
                />
              </span>
            )
            let columnRangosAsignar = item.titleHeader == 'Rangos' && (
              <span className={!row.select ? customStyle : ''}>
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault()
                    onClickRangosyAsignar(row.id ? row.id : row)
                  }}
                >
                  <i className={'fa fa-bullseye'} />
                  &nbsp; {item.bodyColumn}{' '}
                </a>
              </span>
            )
            let ajusteOption = item.titleHeader == 'Ajustes' && (
              <span>
                <Button
                  bsSize="xsmall"
                  disabled={row.proyectoActivo ? true : false}
                  onClick={e => {
                    e.preventDefault()
                    onClickArrayLink(row.id ? row.id : row)
                  }}
                >
                  {' '}
                  <i className={'fa fa-thumb-tack'} />
                  &nbsp; {item.bodyColumn}{' '}
                </Button>
              </span>
            )
            let radioSelectOption = item.customRadioCheck && (
              <span>
                <input
                  type={item.customRadioCheck == 'checkbox' ? 'checkbox' : 'radio'}
                  name="site_name"
                  checked={row.select}
                  onClick={e => {
                    e.preventDefault()
                    onClickArrayLinkRadioCheck(row.id ? row.id : row)
                  }}
                />{' '}
                &nbsp; {item.bodyColumn}{' '}
              </span>
            )
            let changeOption = item.titleHeader == 'Acción' && (
              <span>
                <a
                  href="#"
                  className={row.estadoCambioDestinoId == 2 || row.estadoCambioDestinoId == null ? '' : 'disabled'}
                  onClick={e => {
                    e.preventDefault()
                    onClickArrayLink(row.id ? row.id : row)
                  }}
                >
                  <i className={row.flagActive ? 'fa fa-eye' : 'fa fa-refresh'} />
                  &nbsp; {row.flagActive ? 'Ver' : item.bodyColumn}{' '}
                </a>
              </span>
            )

            let field = (
              <div>
                {arrayLinkOption}
                {arraySeleccionOption}
                {columnRangosAsignar}
                {ajusteOption}
                {radioSelectOption}
                {changeOption}
              </div>
            )

            return field
          }}
        >
          {item.titleHeader}
        </TableHeaderColumn>
      )
    })
  }

  if (arrayChange || onClickChangeLink) {
    arrayChange.map(item => {
      tableColumns.splice(
        item.pos ? item.pos : tableColumns.length - 1,
        0,
        <TableHeaderColumn
          rowSpan={rowSpan}
          headerAlign={'center'}
          dataAlign={'center'}
          key={-2}
          dataField={'actions'}
          className={equalSize ? equalSize : !document ? 'assets-table-action' : ''}
          columnClassName={equalSize ? equalSize : !document ? 'assets-table-action' : ''}
          dataFormat={(cell, row) => {
            let arrayLinkOption = item.goTo && (
              <span className={row.evaluacionActiva ? customStyle : ''}>
                <a
                  href="#"
                  style={{ textDecoration: 'underline' }}
                  onClick={e => {
                    e.preventDefault()
                    onClickChangeLink(e, row.id ? row.id : row, item.goTo)
                  }}
                >
                  {' '}
                  {item.bodyColumn}{' '}
                </a>
              </span>
            )
            let arraySelecciónOption = item.titleHeader.includes('Selección') && (
              <span>
                <input
                  type="checkbox"
                  defaultChecked={row.select ? row.select : row.notificable}
                  onChange={e => {
                    onClickSelecion(e, row.id ? row.id : row)
                  }}
                />
              </span>
            )
            let columnRangosAsignar = item.titleHeader == 'Rangos' && (
              <span className={!row.select ? customStyle : ''}>
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault()
                    onClickRangosyAsignar(row.id ? row.id : row)
                  }}
                >
                  <i className={'fa fa-bullseye'} />
                  &nbsp; {item.bodyColumn}{' '}
                </a>
              </span>
            )
            let ajusteOption = item.titleHeader == 'Ajustes' && (
              <span>
                <Button
                  bsSize="xsmall"
                  disabled={row.actualizarProyecto ? true : false}
                  onClick={e => {
                    e.preventDefault()
                    onClickChangeLink(row.id ? row.id : row)
                  }}
                >
                  {' '}
                  <i className={'fa fa-thumb-tack'} />
                  &nbsp; {item.bodyColumn}{' '}
                </Button>
              </span>
            )
            let radioSelectOption = item.customRadioCheck && (
              <span>
                <input
                  type={item.customRadioCheck == 'checkbox' ? 'checkbox' : 'radio'}
                  name="site_name"
                  checked={row.select}
                  onClick={e => {
                    e.preventDefault()
                    onClickArrayLinkRadioCheck(row.id ? row.id : row)
                  }}
                />{' '}
                &nbsp; {item.bodyColumn}{' '}
              </span>
            )
            let changeOption = item.titleHeader == 'Acción' && (
              <span>
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault()
                    onClickChangeLink(row.id ? row.id : row)
                  }}
                >
                  <i className={row.flagActive ? 'fa fa-eye' : 'fa fa-refresh'} />
                  &nbsp; {row.flagActive ? 'Ver' : item.bodyColumn}{' '}
                </a>
              </span>
            )

            let field = (
              <div>
                {arrayLinkOption}
                {arraySelecciónOption}
                {columnRangosAsignar}
                {ajusteOption}
                {radioSelectOption}
                {changeOption}
              </div>
            )

            return field
          }}
        >
          {item.titleHeader}
        </TableHeaderColumn>
      )
    })
  }

  let newData = []
  if (data && data.length !== undefined) {
    data.forEach(x => {
      if (x.show !== undefined) {
        if (x.show) {
          newData.push(x) 
        }
      } else {
        newData.push(x) 
      }
    })
  }

  return (
    <BootstrapTable
      striped
      containerClass="table-responsive-bootstrap"
      bordered={false}
      pagination={!isNoPagination ? true : false}
      data={newData}
      options={tableOptions}
      remote={false}
      selectRow={selectRowCheck ? selectRowPropCheck : {}}
      cellEdit={cellEditCheck ? cellEditProp : {}}
      keyField="id"
      search={search}
      multiColumnSearch={multiColumnSearch}
      footer={footer}
      footerData={footerData || []}
      expandableRow={expandableRow}
      expandComponent={expandComponent}
      expandColumnOptions={expandColumnOptions}
      trClassName={trClassName}
    >
      {tableColumns}
    </BootstrapTable>
  )
}

export default TableData



// WEBPACK FOOTER //
// ./src/components/common/TableData.js